<template>
  <avz-index />
</template>

<script>
// @ is an alias to /src
import Index from '@/components/Index.vue'

export default {
  name: 'avizier-home',
  components: {
    'avz-index': Index
  }
}
</script>
